<template>
  <div>
    <!-- 横並びの４つのアイコン -->
    <div class="like4frame">
      <div
        v-for="item in likes"
        :key="item.value"
        class="mr-2"
        @click="showDialog(item)"
      >
        <LikeIcon4
          :label="item.value" 
          :icon="item.categoryIcon"
          :selected="selectedGroup.includes(item.value)"
        />
      </div>
    </div>
    <!-- 一旦コメントアウト -->
    <!--
    <v-col
      cols="12"
      class="pt-0 pb-0"
      style="margin-left:-12px;clear:left"
    >
      <div>
        <chip
          v-for="item in selectedLike"
          :key="item.value"
          :text="item.text"
          :value="item.value"
          :selected="true"
          @click="removeChip(item.value)"
        ></chip>
      </div>
    </v-col>
    -->
    <v-dialog
      v-model="dialog.isShow"
      persistent
      transition="dialog-right-transition"
      scrollable
      content-class="v-dialog-form-bottom"
    >
      <v-card>
        <!-- ヘッダー -->
        <v-card-title
          class="ma-0 pa-0"
        >
          <div
            style="height: 54px;width:100%;position: relative"
          >
            <div
              class="caption text-center card-title"
              v-text="dialog.text">
            </div>
            <svg
              class="close-button"
              @click="dialog.isShow = false"
              width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.3 0.709956C13.1131 0.522704 12.8595 0.417471 12.595 0.417471C12.3305 0.417471 12.0768 0.522704 11.89 0.709956L6.99997 5.58996L2.10997 0.699956C1.92314 0.512704 1.66949 0.407471 1.40497 0.407471C1.14045 0.407471 0.886802 0.512704 0.699971 0.699956C0.309971 1.08996 0.309971 1.71996 0.699971 2.10996L5.58997 6.99996L0.699971 11.89C0.309971 12.28 0.309971 12.91 0.699971 13.3C1.08997 13.69 1.71997 13.69 2.10997 13.3L6.99997 8.40996L11.89 13.3C12.28 13.69 12.91 13.69 13.3 13.3C13.69 12.91 13.69 12.28 13.3 11.89L8.40997 6.99996L13.3 2.10996C13.68 1.72996 13.68 1.08996 13.3 0.709956Z" fill="#929191"/>
            </svg>
          </div>
        </v-card-title>
        <!-- ボディー -->
        <v-card-text class="mx-2 my-0 pa-0">
          <div class="like3frame">
            <!-- ALL -->
            <div
              class="mx-2 mb-4"
              @click="clickAll"
            >
              <LikeIcon3
                label="ALL"
                :icon="groupIcon"
                :selected="dialog.items.length === dialog.selectedItem.length"
              />
            </div>
            <!-- Category -->
            <div
              v-for="item in dialog.items"
              class="mx-2 mb-4"
              :key="item.value"
              @click="clickChip(item.value)"
            >
              <LikeIcon3
                :label="item.text"
                :icon="item.icon"
                :selected="dialog.selectedItem.includes(item.value)"
              />
            </div>
          </div>
          <div class="button-area">
            <btn
              @click="clickSearch"
              text="Explore"
            ></btn>
          </div>
          <div class="bottom-dummy">
          </div>
        </v-card-text>
      </v-card>
      <div class="bottom-shadow"></div>
    </v-dialog>
  </div>
</template>

<script>
import service from '@/plugins/service'
import btn from '@/components/Like/Button'
import chip from '@/components/Like/Chip'
import LikeIcon3 from '@/components/Like/LikeIcon3'
import LikeIcon4 from '@/components/Like/LikeIcon4'
import Like from '@/constants/Like'

export default {
  components: {
    btn,
    chip,
    LikeIcon3,
    LikeIcon4,
  },
  props: {
    value: { require: true },
  },
  data: () => ({
    likeList: [],
    dialog: {
      isShow: false,
      text: '',
      items: [],
      selectedItem: [],
    },
  }),
  created() {
    service.likeList.forEach(item => this.likeList.push(item))
  },
  computed: {
    selectedGroup() {
      const result = []
      service.likeList.forEach(like1 => {
        like1.likeList.forEach(like2 => {
          if (Array.isArray(this.value)) {
            if (this.value.includes(like2.value)) {
              result.push(like1.value)
            }
          } else {
            if (this.value == like2.value) {
              result.push(like1.value)
            }
          }
        })
      })
      return result
    },
    selectedLike() {
      const result = []
      service.likeList.forEach(item => {
        item.likeList.forEach(obj => {
          if (Array.isArray(this.value)) {
            if (this.value.includes(obj.value)) {
              result.push(obj)
            }
          } else {
            if (this.value == obj.value) {
              result.push(obj)
            }
          }
        })
      })
      return result
    },
    likes() {
      return Like.list
    },
    groupIcon() {
      if (!this.dialog.text) {
        return undefined
      }
      console.log(this.dialog.text)
      return Like.groupIcon(this.dialog.text)
    },
  },
  methods: {
    clickSearch() {
        const result = []
        // 今まで選択されていたものを追加
        this.value.forEach(val => result.push(val))
        // 今回のダイアログ分を一旦削除
        this.dialog.items.forEach(item => {
          const index = result.indexOf(item.value)
          if (index >= 0) {
            result.splice(index, 1)
          }
        })
        // 今回のダイアログの選択分を追加
        this.dialog.selectedItem.forEach(val => {
          result.push(val)
        })
        this.$emit('input', result)
        this.$emit('change', 'click-like-search')
      this.dialog.isShow = false
    },
    clickChip(value) {
        let index = -1
        for (let i = 0 ; i < this.dialog.selectedItem.length ; i++) {
          if (this.dialog.selectedItem[i] == value) {
            index = i
            break
          }
        }
        if (index > -1) {
          this.dialog.selectedItem.splice(index, 1)
        } else {
          this.dialog.selectedItem.push(value)
        }
    },
    removeChip(value) {
        const result = []
        // 今まで選択されていたものの、クリックされたもの以外を追加
        this.value.forEach(val => {
          if (val != value) {
            result.push(val)
          }
        })
        this.$emit('input', result)
        this.$emit('change', 'remove-like')
    },
    clickAll() {
      if (this.dialog.items.length == this.dialog.selectedItem.length) {
        // すでにすべて選択されていた場合
        this.dialog.selectedItem.splice(0)
      } else {
        this.dialog.items.forEach(item => {
          if (!this.dialog.selectedItem.includes(item.value)) {
            this.dialog.selectedItem.push(item.value)
          }
        })
      }
    },
    showDialog(item) {
      console.log(item)
      this.dialog.text = item.value
      this.dialog.items.length = 0
        this.dialog.selectedItem.length = 0
        item.values.forEach(like2 => {
          this.dialog.items.push(like2)
          if (Array.isArray(this.value)) {
            if (this.value.includes(like2.value)) {
              this.dialog.selectedItem.push(like2.value)
            }
          } else {
            if (this.value == like2.value) {
              this.dialog.selectedItem.push(like2.value)
            }
          }
        })
      this.dialog.isShow = true
    },
  },
}
</script>

<style lang="stylus" scoped>
div.card-title
  height 54px
  line-height 54px
  width 100%
  text-align center
  color black
  font-weight 700
  font-size  18px !important

svg.close-button
  position absolute
  right 21px
  top 21px

.like3frame
  display flex
  flex-wrap wrap
  width 100%
  flex-direction row

.like4frame
  display flex
  flex-direction row

.button-area
  position absolute
  padding 0
  margin 0
  width calc(100% - 16px)
  bottom 16px
  z-index 5

.bottom-shadow
  position absolute
  width 100%
  height 94px
  left 0
  bottom 0
  background: linear-gradient(180deg, rgba(12, 11, 11, 0) 0%, rgba(12, 11, 11, 0.5) 100%);

.bottom-dummy
  height 94px
</style>
